var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%","z-index":"999999999999"}},[(_vm.success)?_c('div',{staticStyle:{"top":"45%","position":"inherit"}},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('b-button',{staticClass:"btn btn-primary",on:{"click":_vm.navigateToLogin}},[_vm._v(_vm._s(_vm.$t('button.login')))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }